import { configureStore, combineReducers } from '@reduxjs/toolkit';
import websiteContextReducer from './reducers/websiteContextReducer';
import siteReducer from './reducers/siteReducer';
import blogReducer from './reducers/blogReducer';
import faqReducer from './reducers/faqReducer';
import authReducer from './reducers/authReducer';

const rootReducer = combineReducers({
  websiteContext: websiteContextReducer,
  sites: siteReducer,
  blog: blogReducer,
  faq: faqReducer,
  auth: authReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

